
import { Component, Prop, Vue } from 'vue-property-decorator'
import { BranchList } from '@/models/manage/BranchList'

/**
 * 教室一覧テーブル
 */
@Component
export default class AcademyBranchListTable extends Vue {
  /** 教室一覧 */
  @Prop()
  private branchList!: BranchList[]

  /**
   * 教室一覧の空判定
   *
   * @returns 教室があればtrue
   */
  private get hasBranches(): boolean {
    return this.branchList.length !== 0
  }
}
